module.exports = __webpack_public_path__ + "static/media/ipadpro_light.40e4a87c.svg";